import { useState } from "react";
import { MapPin, User } from "react-feather";
import RequestLocationsRequest from "./RequestLocationsRequests";
import RequestConsignee from "./RequestConsignee";
import {
  locationValidation,
  validateRequestLocation,
} from "../../../validations/validateRequestCreation";
import { useDispatch, useSelector } from "react-redux";
import { requestActions } from "../../../../store/request-slice";
import LoadingSpinner from "../../../LoadingSpinner";
import { FORMS } from "../../../../const";
import useDynamicValidation from "../../../../hooks/useDynamicValidation";

const FORM = FORMS.REQUEST.LOCATION.form;
const START_LOCATION = FORMS.REQUEST.START_LOCATION.form;
const END_LOCATION = FORMS.REQUEST.END_LOCATION.form;
const LocationConsigneeItem = ({
  dropdown,
  errors,
  editMode,
  onShowLocation,
  isLoading,
  context,
}) => {
  const [tab, setTab] = useState(1);
  const [swicthedToConsigee, setSwitchedToConsigee] = useState(false);
  const hasLocErrors = useSelector((state) => state.request.hasLocErrors);
  const hasConErrors = useSelector((state) => state.request.hasConErrors);
  const submitted = useSelector((state) => state.request.submitted);
  const dispatch = useDispatch();

  const multiConsigneeType = useSelector(
    (state) => state.request.reqMultiConsignee,
  );
  const requestLocationsRequests = useSelector(
    (state) => state.request.requestLocationsRequests,
  );

  const dynamicValidationStatusStart = useDynamicValidation(
    locationValidation,
    START_LOCATION,
    true,
  );

  const dynamicValidationStatusEnd = useDynamicValidation(
    locationValidation,
    END_LOCATION,
    true,
  );

  const validateSetLocations = () => {
    const errors = [];
    const requestStartLocation = requestLocationsRequests.find(
      (location) => location.rlkLocationType === 1,
    );
    const requestEndLocation = requestLocationsRequests.find(
      (location) => location.rlkLocationType === 2,
    );
    const startLocationErrors = validateRequestLocation(
      requestStartLocation,
      dynamicValidationStatusStart,
    );
    const endLocationErrors = validateRequestLocation(
      requestEndLocation,
      dynamicValidationStatusEnd,
    );
    const startLocationValidationFailed =
      Object.keys(startLocationErrors).length > 0;
    const endLocationValidationFailed =
      Object.keys(endLocationErrors).length > 0;
    if (startLocationValidationFailed) {
      dispatch(requestActions.setRequest({ startLocationErrors }));
    }
    if (endLocationValidationFailed) {
      dispatch(requestActions.setRequest({ endLocationErrors }));
    }

    if (startLocationValidationFailed || endLocationValidationFailed) {
      return false;
    }
    if (errors.length > 0) {
      dispatch(requestActions.setRequest({ validationErrors: errors }));
      return false;
    } else {
      return true;
    }
  };

  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <div className="ui top attacehd tablular menu">
            <div
              className={`item ${tab === 1 ? "active" : ""}`}
              style={{
                color:
                  (swicthedToConsigee || submitted) && hasLocErrors
                    ? "#e0b4b4"
                    : "",
                borderColor:
                  (swicthedToConsigee || submitted) && hasLocErrors
                    ? "#e0b4b4"
                    : "",
              }}
              onClick={() => {
                setTab(1);
              }}
            >
              <span>
                <MapPin size={15} style={{ marginRight: "5px" }} />
              </span>
              Location
            </div>
            {multiConsigneeType === 1 && (
              <div
                className={`item ${tab === 2 ? "active" : ""}`}
                style={{
                  color: hasConErrors ? "#e0b4b4" : "",
                  borderColor: hasConErrors ? "#e0b4b4" : "",
                }}
                onClick={() => {
                  dispatch(
                    requestActions.setRequest({ startLocationErrors: {} }),
                  );
                  dispatch(
                    requestActions.setRequest({ endLocationErrors: {} }),
                  );
                  if (validateSetLocations()) {
                    dispatch(
                      requestActions.setRequest({ hasLocErrors: false }),
                    );
                  } else {
                    dispatch(requestActions.setRequest({ hasLocErrors: true }));
                  }
                  setTab(2);
                  setSwitchedToConsigee(true);
                }}
              >
                <span>
                  <User size={15} style={{ marginRight: "5px" }} />
                </span>
                Consignees
              </div>
            )}
          </div>
          <div
            className="ui bottom attached active tab segment"
            style={{ display: tab === 1 ? "block" : "none" }}
          >
            <RequestLocationsRequest
              context={context}
              editMode={editMode}
              onShowLocation={onShowLocation}
              dropdown={{
                locationFlagOptions: dropdown.locationFlagOptions,
                pickDropTypeOptions: dropdown.pickDropTypeOptions,
              }}
              errors={errors}
            />
          </div>
          <div
            className="ui bottom attached active tab segment"
            style={{ display: tab === 2 ? "block" : "none" }}
          >
            <RequestConsignee
              editMode={editMode}
              dropdown={{
                consignmentTypeOptions: dropdown.consignmentTypeOptions,
              }}
              errors={errors}
            />
          </div>
        </>
      )}
    </>
  );
};

export default LocationConsigneeItem;
